import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { Tips } from '../../../shared/models/step.model';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DirectSessionLogicService } from '../../../shared/direct-session-logic.service';
import { Router, NavigationEnd } from '@angular/router';
import { NgClass } from '@angular/common';


@Component({
  selector: 'direct-random-facts',
  template:`
    
    <div class=" "
    [ngClass]="{'hidden-content': factForStep.tipString === 'No tips available for this step'}"
    >
      <div class="direct-random-facts__container__bottom">
        <img class="material-icons" style="fill: white;" src="assets/Icons/{{factForStep.tipIconValue}}.svg">
        {{ factForStep.tipString }}
      </div>
      <div class="tip-ref">   
        <a  style="color: white; font-size: small; text-decoration: none;" 
          href="{{this.urlLinkForTipSource}}" 
          target="_blank">{{factForStep.tipSource}}
        </a>
      </div>
    </div>

  `,
  styleUrls: ['./direct-random-facts.component.scss'],
  host: {'class': 'direct-random-facts'},
  standalone: true,
  imports: [NgClass]
})

export class DirectRandomFactsComponent implements OnInit {
  private unsubscriber = new Subject<void>();
  
  stateChange: boolean = false;
  isHandsetPortrait: boolean = false;

  factForStep: Tips = {} as Tips;

  urlLinkForTipSource: URL = new URL("https://www.google.com");

  constructor(
    private readonly responsive: BreakpointObserver,
    public directSessionLogic: DirectSessionLogicService,
    private readonly router: Router
  ){
    this.router.events.subscribe(event =>{
      if(event instanceof NavigationEnd){
        this.getFactsOnNavEnd( event.urlAfterRedirects );
      }
    })
  }

  ngOnInit():void {
    this.responsive.observe(Breakpoints.HandsetPortrait).subscribe(result => {
      this.isHandsetPortrait = false;

      if (result.matches) {
        this.isHandsetPortrait = true;
      }
    });
  }

  async getFactsOnNavEnd(urlAfterRedirects: string){
    // console.log("event: ", urlAfterRedirects);
    let stepToCheck = urlAfterRedirects.split("/").pop() ?? "";
    if(stepToCheck != ""){
      this.factForStep = await this.directSessionLogic.getFactsForGivenStep(stepToCheck);
    }else{
      console.log("no step to check");
      this.factForStep = await this.directSessionLogic.getFactsForGivenStep("plans");
    }

    if(this.factForStep.tipSourceUrl != ""){
      this.urlLinkForTipSource = new URL(this.factForStep.tipSourceUrl);
    }
  }

  ngOnDestroy(): void {
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }
}
